/** Shared Focus / directory multi-select menu leading-check chrome. */
export const getFilterMenuLeadingStyles = (theme) => ({
  filterMenuLeading: {
    minWidth: 20,
    marginRight: theme.spacing(1),
    color: '#143d66',
    justifyContent: 'flex-start',
    '&.MuiListItemIcon-root': {
      minWidth: 20,
      marginRight: theme.spacing(1),
    },
  },
  filterMenuLeadingSpacer: {
    display: 'inline-block',
    width: 18,
  },
})

export const getFilterMenuItemSelectedStyles = (theme) => ({
  backgroundColor: '#143d66 !important',
  color: theme.palette.common.white,
  '& .MuiTypography-root': {
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  '& $filterMenuLeading': {
    color: theme.palette.common.white,
  },
})
